<template>
	<v-row justify="center">
		<v-dialog v-if="dialog" v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Stok Opname</span>
					<span class="pl-2 font-weight-bold">{{ detailOpname.product_stock_opname_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="4">
							<div class="text-subtitle-1 font-weight-bold">Penanggung Jawab</div>
							<div class="pt-1">{{ detailOpname.product_stock_opname_pic_name }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="text-subtitle-1 font-weight-bold">Tanggal Stok Opname</div>
							<div class="pt-1">{{ detailOpname.product_stock_opname_datetime | haritanggal }}</div>
						</v-col>
            <v-col cols="6" md="4">
							<div class="text-subtitle-1 font-weight-bold">Status</div>
							<div class="pt-1">{{ detailOpname.opname_status | toOpnameStatus }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="text-subtitle-1 font-weight-bold">Catatan</div>
							<div class="pt-1">{{ detailOpname.product_stock_opname_note }}</div>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailOpname.product_stock_opname_detail" hide-default-footer>
							<template v-slot:item.product_stock_opname_detail_quantity="{ item }">
								<div>{{ item.product_stock_opname_detail_quantity | toNumber }}</div>
							</template>
						</v-data-table>
					</v-card>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'product_stock_opname_detail_product_name', sortable: true},
			{ text: 'Jumlah', value: 'product_stock_opname_detail_quantity', sortable: true, align: 'end' },
			],
		}
	},
	computed:{
		...mapState('stockOpname', ['detailOpname']),
	},
	props: {
		dialog: Boolean,
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
	}
};
</script>
